export default "__VITE_ASSET__bd98dece__"